export default __webpack_public_path__ + "static/media/plus.0b1deb7f.svg";